import { Box } from '@chakra-ui/react';
import Career from '../../components/Career/Career';

export default function MyCareerPage() {
    return (
        <Box bg='#FCE9A3'>
            <Career />
        </Box>
    );
}
